import type { Logger, EditorSDK } from '@wix/wix-data-client-common-standalone'

interface MultilingualProps {
  editorSdkProxy: EditorSDK
  logger: Logger
  secondaryLanguage?: string
}

export const openMultilingualDashboard = ({
  logger,
  editorSdkProxy,
  secondaryLanguage,
}: MultilingualProps): void => {
  editorSdkProxy.editor
    .openDashboardPanel({
      url: `/multilingual${
        secondaryLanguage
          ? '?secondaryLanguage=' + encodeURIComponent(secondaryLanguage)
          : ''
      }`,
      closeOtherPanels: false,
    })
    .catch(error =>
      logger.error(
        new Error('Failed to open multilingual dashboard', { cause: error }),
      ),
    )
}
